//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    project: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      formData: {},
      newLocationForm: {
        title: null,
        surface: null,
      },
      currentTab: 1,
    };
  },
  mounted() {
    this.formData = JSON.parse(JSON.stringify(this.project));
    this.formData.organic_matter_content = [this.formData.organic_matter_content_min, this.formData.organic_matter_content_max];
    this.formData.moisture_content = [this.formData.moisture_content_min, this.formData.moisture_content_max];
    if (this.formData.district) {
      this.formData.district = this.formData.district.uuid;
    }
  },
  methods: {
    updateLocations(locations) {
      this.formData.locations = JSON.parse(JSON.stringify(locations));
    },
    updateLocationSpecies(index, species) {
      this.formData.locations[index].species = species.map(s => s.uuid);
    },
    submit() {
      this.$emit('submit', this.parseData(this.formData));
    },
    parseData(data) {
      return {
        uuid: data.uuid,
        title: data.title,
        client: data.client.uuid,
        locations: this.parseLocations(data.locations),
        project_number: data.project_number,
        project_surface: parseInt(data.project_surface),
        city: data.city,
        since: data.since,
        district: data.district,
        material: data.material,
        moisture_content_min: data.moisture_content[0] || 1,
        moisture_content_max: data.moisture_content[1] || 1,
        sun: data.sun,
        organic_matter_content_min: data.organic_matter_content[0] || 1,
        organic_matter_content_max: data.organic_matter_content[1] || 1,
        lime_content: data.lime_content,
        monitoring_per_year: data.monitoring_per_year,
        mowing_and_cleaning: data.mowing_and_cleaning,
        contract_until: parseInt(data.contract_until),
        warranty: data.warranty,
        herbs_to_grass_percentage: parseInt(data.herbs_to_grass_percentage),
        species_to_sown_percentage: parseInt(data.species_to_sown_percentage),
        ...data.thumbnail_temp?.files ? {image: data.thumbnail_temp.files[0].file} : {},
      };
    },
    parseLocations(locations) {
      const newLocations = [];
      locations.forEach((loc) => {
        const newLocation = {
          uuid: loc.uuid,
          title: loc.title,
          surface: parseInt(loc.surface),
          species: loc.species.map(s => s.uuid),
          warranty: loc.warranty,
          herbs_to_grass_percentage: loc.herbs_to_grass_percentage,
          species_to_sown_percentage: loc.species_to_sown_percentage,
        };
        newLocations.push(newLocation);
      });
      return newLocations;
    },
    failedValidation(data) {
      for (let value of Object.entries(data)) {
        value = value[1];
        if (value.$attrs['tab-index']) {
          this.currentTab = value.$attrs['tab-index'];
          return;
        }
      }
      this.currentTab = 1;
      this.$toast.error('Let op! Het project is niet opgeslagen! Niet alle velden zijn correct ingevuld.');
    },
    addLocation() {
      if (!confirm('Weet je zeker dat je een nieuwe locatie wilt toevoegen?')) {
        return;
      }
      this.formData.locations.push({
        title: '',
        surface: null,
        species: [],
        uuid: null,
      });
      this.currentTab = this.formData.locations.length + 1;
    },
  },
};
